export const CLIENT_LIST = '/client-success/client-list';
export const CREATE_CLIENT = '/client-success/create-client';
export const UPDATE_CLIENT = '/client-success/update-client/:client_id';

export const CLIENTS_TAB_ROUTES = [CLIENT_LIST, CREATE_CLIENT, UPDATE_CLIENT];
